<template>
  <div class="cart-container" @click="toggleClick">
    <svg-icon icon-class="cart" />
    <div v-if="badge > 0" class="badge-container">
      <span class="badge">{{badge}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cart",
  props: {
    badge: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toggleClick() {
      this.$emit("toggleClick");
    }
  }
};
</script>

<style scoped>
.cart-container {
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.badge-container {
  padding: 0 4.7px;
  background-color: #d0021b;
  border-radius: 8px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 8px;
}
.badge {
  font-size: 12px;
  font-weight: 400;
  color: white;
}
</style>
